import React, { useEffect, useState } from 'react'
// import AlsoKnownAs from '../AlsoKnownAs'
import { truevalueedit } from '../../Movie/truevalueedit'
import { Auth } from 'aws-amplify'
import AwsConfig from '../../../Config/AwsConfig'
// import { ToastStyle } from '../../Data/MovieStaticData'
// import { toast } from 'react-toastify'
// import Updateperson from '../../../Services/Mutations/Updateperson'
import CreatePersonService from '../../../Services/Mutations/CreatePersonService'
import { useHistory } from 'react-router-dom'
import BasicInfoUi from './BasicInfoUi'
import ApproveCreateMoviePerson from '../../Movie/ApproveCreateMoviePerson'
import GetUserPermissions from '../../../Services/Queries/GetUserPermissions'
import { DefinedPermissions } from '../../Constants/Permissions'

function BasicInfoCreate(props) {
  const {
    activeSection,
    handleSectionClick,
    PersoninputData,
    personName,
    personNamete,
    error,
    // handleNameChange,
    // handleNameteChange,
    sendInputPersondata,
    sendValuechangedBoolean,
    shortBio,
    shortBiote,
    // handleShortbioChange,
    // handleShortbioteChange,
    valueChanged,
    updateInputPersonData,
    wikipediaURL,
    // handleWikipediaURLChange,
    section,
    setWikipediaURL,
    // personData,
    getUpdatedData,
    setShortbio,
    setShortbiote,
    setpersonNamete,
    setpersonName,
    setLoader,
    mode,
  } = props
  const history = useHistory()
  const [loadPopup, setLoadPopup] = useState(false)
  const [EDitApproveOptionBoolean, setEDitApproveOptionBoolean] = useState(false)
  const [renderedPerson, setRenderedPerson] = useState({})
  let loggedInUserHandle = ''
  const loggedInUserEmail = Auth.user.attributes ? Auth.user.attributes.email : ''
  if (loggedInUserEmail) {
    const emailParams = loggedInUserEmail.split('@')
    loggedInUserHandle = '@' + emailParams[0]
  }

  const handleNameChange = e => {
    setpersonName(e.target.value)
    sendValuechangedBoolean('name', true)
  }

  // function for handling change of name telugu
  const handleNameteChange = e => {
    setpersonNamete(e.target.value)
    sendValuechangedBoolean('namete', true)
  }

  // function for handling change of shotbio english
  const handleShortbioChange = e => {
    sendValuechangedBoolean('bio', true)
    setShortbio(e.target.value)
  }

  // function for handling change of shotbio Telugu
  const handleShortbioteChange = e => {
    sendValuechangedBoolean('biote', true)
    setShortbiote(e.target.value)
  }

  // function for handling change of shotbio Telugu
  const handleWikipediaURLChange = e => {
    sendValuechangedBoolean('wiki', true)
    setWikipediaURL(e.target.value)
  }

  const handleTextAreaChange = newValue => {
    const updatedInfo = { ...PersoninputData }
    updatedInfo.Almamater_En = newValue[0]
    updatedInfo.Almamater_Te = newValue[1]
    sendInputPersondata(updatedInfo)
    sendValuechangedBoolean('Almamater_En', true)
  }

  const dateOfBirth = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[0] + tempValue[1] + tempValue[2]
    return tempeoryValue
  }

  const dateOfBirthdate = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[1] + tempValue[2]
    return tempeoryValue
  }

  const dateOfBirthyear = editvalue => {
    const tempValue = editvalue.split('-')
    const tempeoryValue = tempValue[0]
    return tempeoryValue
  }

  const validation = () =>
    personName &&
    personNamete &&
    PersoninputData.personPoster &&
    shortBio.length > 3 &&
    shortBiote.length > 3 &&
    wikipediaURL.length >= 5 &&
    (valueChanged.name ||
      valueChanged.namete ||
      valueChanged.bio ||
      valueChanged.biote ||
      valueChanged.wiki ||
      valueChanged.dob ||
      valueChanged.PlaceofBirthEn ||
      valueChanged.PlaceofBirthTe ||
      valueChanged.poster ||
      valueChanged.Almamater_En ||
      valueChanged.popularyKnownAs_En ||
      valueChanged.popularyKnownAs_Te)

  const saveBasicInfo = async () => {
    setLoader(true)
    const input = {
      //   PK: personData.PK,
      //   SK: personData.SK,
      personType: PersoninputData.personType,
      moderatorID: Auth.user.username,
      moderatorHandle: loggedInUserHandle,
    }
    truevalueedit(
      [valueChanged.popularyKnownAs_En, PersoninputData.popularyKnownAs_En],
      input,
      'popularyKnownAs_En',
    )
    truevalueedit(
      [valueChanged.popularyKnownAs_Te, PersoninputData.popularyKnownAs_Te],
      input,
      'popularyKnownAs_Te',
    )
    truevalueedit([valueChanged.Almamater_En, PersoninputData.Almamater_En], input, 'almamater_En')
    truevalueedit([valueChanged.Almamater_En, PersoninputData.Almamater_Te], input, 'almamater_Te')
    truevalueedit([valueChanged.name, personName], input, 'name_En')
    truevalueedit([valueChanged.namete, personNamete], input, 'name_Te')
    truevalueedit([valueChanged.bio, shortBio], input, 'about_En')
    truevalueedit([valueChanged.biote, shortBiote], input, 'about_Te')
    truevalueedit([valueChanged.wiki, wikipediaURL], input, 'personWikiURL')
    truevalueedit(
      [
        valueChanged.dob,
        PersoninputData.dateOfBirth ? dateOfBirth(PersoninputData.dateOfBirth) : '',
      ],
      input,
      'dateOfBirth',
    )
    truevalueedit(
      [
        valueChanged.dob,
        PersoninputData.dateOfBirth ? dateOfBirthdate(PersoninputData.dateOfBirth) : '',
      ],
      input,
      'birthdayMonthAndDate',
    )
    truevalueedit(
      [
        valueChanged.dob,
        PersoninputData.dateOfBirth ? dateOfBirthyear(PersoninputData.dateOfBirth) : '',
      ],
      input,
      'birthYear',
    )
    truevalueedit(
      [valueChanged.PlaceofBirthEn, PersoninputData.PlaceofBirthen],
      input,
      'placeOfBirth_En',
    )
    truevalueedit(
      [valueChanged.PlaceofBirthTe, PersoninputData.PlaceofBirthte],
      input,
      'placeOfBirth_Te',
    )
    const cdnurl = AwsConfig.movieCdnUrl
    if (PersoninputData.personPoster && PersoninputData.personPoster.includes(cdnurl)) {
      const posterUrl = PersoninputData.personPoster.replace(cdnurl, '')
      truevalueedit([valueChanged.poster, posterUrl], input, 'posterURL')
    }

    try {
      const create = await CreatePersonService(input)
      // console.log(createlog)
      // if (create.statusCode === 'A005') {
      //   toast.success('created person successfully', ToastStyle)
      //   history.push(`/editperson?${encodeURI(create?.PK || '')}`)
      //   getUpdatedData()
      //   setLoader(false)
      //   // return upadatelog
      // }

      if (create.statusCode === 'A005') {
        const rendeedPersondataTemp = { ...renderedPerson }
        rendeedPersondataTemp.PK = create.PK
        rendeedPersondataTemp.SK = create.SK
        setRenderedPerson(rendeedPersondataTemp)
      }

      if (create.statusCode === 'A005') {
        if (EDitApproveOptionBoolean) {
          setLoadPopup(true)
          setLoader(false)
        } else {
          history.push(`/editperson?${encodeURI(create?.PK || '')}`)
          getUpdatedData()
          setLoader(false)
        }
      }
    } catch (error) {
      setLoader(false)
      console.warn(error)
    }
  }

  useEffect(() => {
    const getPermissions = async () => {
      const permissionInput = {
        mobileNumber: Auth.user.attributes.phone_number,
      }
      const userPermissions = await GetUserPermissions(permissionInput)
      const permissions = []
      const permissionsArr = []
      if (userPermissions && userPermissions.userRolesAndPermissions) {
        userPermissions.userRolesAndPermissions.map(item => {
          permissions.push(...item.permissions)
          return item
        })
        permissions.map(permission => {
          permissionsArr.push(permission.name)
          return permission
        })
      }

      const EDitApproveOption = permissionsArr.includes(
        DefinedPermissions.DisplayApprovePersonOption,
      )
      setEDitApproveOptionBoolean(EDitApproveOption)
    }

    getPermissions()
  }, [])

  return (
    <>
      <BasicInfoUi
        activeSection={activeSection}
        handleSectionClick={handleSectionClick}
        PersoninputData={PersoninputData}
        personName={personName}
        personNamete={personNamete}
        error={error}
        sendInputPersondata={sendInputPersondata}
        sendValuechangedBoolean={sendValuechangedBoolean}
        shortBio={shortBio}
        shortBiote={shortBiote}
        valueChanged={valueChanged}
        updateInputPersonData={updateInputPersonData}
        wikipediaURL={wikipediaURL}
        section={section}
        getUpdatedData={getUpdatedData}
        setShortbio={setShortbio}
        setShortbiote={setShortbiote}
        handleWikipediaURLChange={handleWikipediaURLChange}
        handleNameChange={handleNameChange}
        handleNameteChange={handleNameteChange}
        handleShortbioChange={handleShortbioChange}
        handleShortbioteChange={handleShortbioteChange}
        saveBasicInfo={saveBasicInfo}
        validation={validation}
        handleTextAreaChange={handleTextAreaChange}
        mode={mode}
      />
      {loadPopup ? (
        EDitApproveOptionBoolean &&
        loadPopup && (
          <ApproveCreateMoviePerson
            loadPopup={loadPopup}
            setLoadPopup={setLoadPopup}
            moviePerson={'person'}
            movieData={renderedPerson}
          />
        )
      ) : (
        <></>
      )}
    </>
  )
}

export default BasicInfoCreate
